import CountWords from '@/src/components/CountWords/CountWords';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { useSingleImageEffect } from '@/src/components/Upload';
import Layout from '@/src/layout/EditorPageLayout/EditorPageLayout';
import { get } from 'lodash';
import React from 'react';
import { useParams } from 'react-router';
import { Form, Input } from 'src/components/Antd';
import SalesChannelHOC, {
  SelectHOC,
} from 'src/constrains/SalesChannelHOC/SalesChannelHOC';
import { SalesChannelModeAccessControlHOC } from 'src/constrains/SalesChannelModeAccessControl';
import {
  EnumMultiLanguageType,
  useQueryLanguageListContentEditor,
} from 'src/constrains/SalesChannelMultiLanguageSelect';
import { useI18n } from 'src/hooks/useRouterChange';
import Image from 'src/pages/ProductEditor/Components/Image/Image1';
import Section from 'src/pages/SalesCannelVersion/Components/SectionContainer';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import {
  getVoucherDetail,
  postVoucherDetail,
} from 'src/request/salesChannel/discounts/voucher';
import { msg } from 'src/tools/message';
import { i18nGet } from 'src/tools/tools';
import { EnumSalesChannelMultiLanguage } from 'src/types/server/params';
import { discountPermissions } from '../../Components/hooks/permissions';
import Left from './Header/TopLeft';
import Right from './Header/TopRight';
import Summary from './Summary';
import css from './css.module.less';
const salesChannelMultiLanguageQueryParams = {
  [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true,
  //  salesChannelMultiLanguageUpdate: true,
};
const salesChannelMultiLanguageParams = {
  [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true,
  [EnumSalesChannelMultiLanguage.multiLanguageForceUpdate]: true,
};

const Item = Form.Item;

const SalesChannelVoucher = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { discountUuid, uuid }: any = useParams();
  const { canViewDetail, canEdit } = discountPermissions(uuid);
  const [loaded, setLoaded] = React.useState(false);
  const [hasModified, setHasModified] = React.useState(false);
  const [data, setData] = React.useState(null);
  const [storeData, setStoreData] = React.useState(null);
  const [salesChannelName, setSalesChannelName] = React.useState('');
  const currentLanguage = useQueryLanguageListContentEditor();
  const [form] = Form.useForm();
  const getData = () => {
    getVoucherDetail(
      uuid,
      discountUuid,
      salesChannelMultiLanguageQueryParams,
    ).then((res) => {
      console.log(res);
      const { storeVoucher, salesChannelVoucher } = res;
      const { description: sD, featureImage: sI } = storeVoucher || {};
      const {
        description: scD,
        featureImage: scI,
        salesChannelName = '',
      } = salesChannelVoucher || {};
      setData(salesChannelVoucher);
      setStoreData(storeVoucher || {});
      setSalesChannelName(salesChannelName);
      form.setFieldsValue({
        storeVoucher: {
          featureImage: sI,
          description: sD,
        },
        salesChannelVoucher: {
          featureImage: scI,
          description: scD,
        },
      });
      setLoaded(true);
    });
  };
  React.useEffect(() => {
    if (canViewDetail) {
      getData();
    }
  }, [currentLanguage]);

  const ele = [
    { child: <Summary data={storeData} /> },
    { child: <VoucherBasicInfo disableEdit={!canEdit} /> },
  ];
  return (
    <Form
      form={form}
      onFinish={(v) => {
        //console.log(v);
        const { salesChannelVoucher } = v || {};
        const obj = {
          ...data,
          ...(salesChannelVoucher || {}),
        };
        postVoucherDetail(obj, salesChannelMultiLanguageParams).then((res) => {
          msg.success(getI18n('general.successfullyupdated'));
          setHasModified(false);
        });
      }}
      name='salesChannelVoucherForm'
      onValuesChange={() => {
        setHasModified(true);
      }}>
      {loaded && (
        <Layout
          topLeft={
            <Left
              salesChannelName={salesChannelName}
              name={get(storeData, 'voucherNo')}
              getI18n={getI18n}
            />
          }
          topRight={
            <Right
              disableEdit={!canEdit}
              hasModified={hasModified}
              onSubmit={() => {
                form.submit();
              }}
            />
          }
          elements={ele}
        />
      )}
    </Form>
  );
};
export default SalesChannelModeAccessControlHOC(
  SalesChannelHOC(SelectHOC(SalesChannelVoucher), {
    type: EnumMultiLanguageType.SalesChannelDiscountsGiftPurchase,
  }),
);

const VoucherBasicInfo = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { disableEdit } = props;
  const storeBase = 'storeVoucher';
  const salesChannelBase = 'salesChannelVoucher';
  const storeImage = [storeBase, 'featureImage'];
  const storeDes = [storeBase, 'description'];
  const salesChannelImage = [salesChannelBase, 'featureImage'];
  const salesChannelDes = [salesChannelBase, 'description'];
  return (
    <SectionWrapper
      title={getI18n('salesChannelVoucher.basicInfo.voucherBasicInformation')}
      containerClassName={css.container}>
      <Section bottomBorder>
        <ItemWrapper
          //name={'Voucher Description*'}
          title={`${getI18n(
            'salesChannelVoucher.basicInfo.voucherDescription',
          )}*`}
          rightSubTitle={getI18n('salesChannelVoucher.basicInfo.desTip')}>
          <Input
            formProps={{
              name: storeDes,
            }}
            size='large'
            disabled
          />
        </ItemWrapper>
        <ItemWrapper
          title={`${getI18n('general.hOCTitle.featureImage')}*`}
          rightSubTitle={getI18n('salesChannelVoucher.basicInfo.imageTip')}>
          <Item name={storeImage}>
            <_Image disabled />
          </Item>
        </ItemWrapper>
      </Section>
      <Section bottomBorder>
        <ItemWrapper
          title={getI18n('salesChannelVoucher.basicInfo.sectionTip1')}
          rightSubTitle={getI18n(
            'salesChannelVoucher.basicInfo.displayonshopperend.',
          )}
          rightPart={
            <Item
              shouldUpdate={(p, c) => {
                const pV = get(p, salesChannelDes);
                const cV = get(c, salesChannelDes);
                return pV !== cV;
              }}>
              {({ getFieldValue }) => {
                const word = getFieldValue(salesChannelDes);
                const count = (word || '').length;
                return <CountWords count={count} allCount={500} />;
              }}
            </Item>
          }>
          <Input
            formProps={{
              name: salesChannelDes,
            }}
            size='large'
            disabled={disableEdit}
            maxLength={500}
          />
        </ItemWrapper>
        <ItemWrapper
          title={getI18n('salesChannelVoucher.basicInfo.sectionTip3')}
          rightSubTitle={getI18n(
            'salesChannelVoucher.basicInfo.displayonshopperend.',
          )}>
          <Item name={salesChannelImage}>
            <_Image disabled={disableEdit} />
          </Item>
        </ItemWrapper>
      </Section>
    </SectionWrapper>
  );
};

const _Image = (props) => {
  const { value, onChange, id, disabled } = props;
  const [fileList, setFileList] = React.useState(value ? [value] : []);
  useSingleImageEffect(value, fileList, setFileList);
  const _onChange = (img) => {
    onChange(img);
  };
  return (
    <div style={{ width: '100%' }} id={id}>
      <Image
        className={css.image}
        onChange={_onChange}
        fileList={fileList}
        setFileList={setFileList}
        disabled={disabled}
      />
    </div>
  );
};

// const Summary = (props) => {
//   return <SectionWrapper title='Summary'></SectionWrapper>;
// };
